let globalSessionId = null

jQuery(document).ready(function() {


    $('.block-overlay-btn').click(function() {
        // $('.block-overlay-wrapper').removeClass('active');
        $('.block-overlay-wrapper').slideUp(400, function() {});
        $('.quiz-wrapper').slideDown(500, function() {});
    });


    // BEGIN script for slider-logos
    jQuery('.slider-logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 4500,
        fade: false,
        pauseOnHover: false,
        speed: 600,
        centerMode: true,
        variableVidth: true,
    });
    // END script for slider-logos

    // BEGIN script for slider-3-per-row
    jQuery('.slider-3-per-row').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 4500,
        fade: false,
        pauseOnHover: false,
        speed: 600,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
    // END script for slider-3-per-row

    // BEGIN script for slider-simple
    jQuery('.slider-simple').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        adaptiveHeight: false,
        // autoplay: true,
        autoplaySpeed: 5500,
        fade: false,
        pauseOnHover: false,
        speed: 1200,
        centerMode: true,
        variableVidth: true,
    });
    // END script for slider-simple

    // BEGIN of script for slider-on-mobile-only
    /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.slider-on-mobile-only').each(function() {
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() > 767) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            } else {
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        adaptiveHeight: false,
                        mobileFirst: true,
                        autoplay: true,
                        autoplaySpeed: 5000,
                        fade: false,
                        pauseOnHover: false,
                        speed: 600,
                        // centerMode: true,
                        // variableWidth: true,
                    });
                }
            }
        });
    });
    // END of script for slider-on-mobile-only

    // BEGIN script for accordion
    $('.accordion-item-nav').click(function() {
        var _accItemParent = $(this).parents('.accordion-item');
        if (_accItemParent.hasClass('active')) {
            $('.accordion-item').removeClass('active');
            $('.accordion-item .accordion-item-content').slideUp(400, function() {});
        } else {
            $('.accordion-item').removeClass('active');
            $('.accordion-item .accordion-item-content').slideUp(400);
            _accItemParent.addClass('active');
            _accItemParent.find('.accordion-item-content').slideDown(400, function() {});
        }
    })
    $('.accordion-item:first .accordion-item-nav').click();
    // END script for accordion

    // BEGIN of script for tabs
    $('.tabs-nav-item').click(function() {
        var _id = $(this).attr('href');
        var _targetElement = $(this).parents('.tabs-wr').find(_id);
        $('.tabs-nav-item').removeClass('active');
        $('.tabs-nav-item-wrapper').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.tabs-nav-item-wrapper').addClass('active');
        $('.tabs-item').removeClass('active');
        _targetElement.addClass('active');
        return false;
    });

    $('.btn-close-tab').click(function() {
        $(this).parents('.tabs-item').removeClass('active');
    })
    // $('.tabs-nav-item:last-child').click();

    $('.btn-reset-selected').click(function() {
        $(this).parents('.guiz-step-item').find('input[type=checkbox]').prop('checked', false);
    })

    // END of script for tabs




    // BEGIN QUIZ -----------------------------------------------------

    // BEGIN script for inputs form styles
    function inputNotEmpty() {
        $('.input-with-label input, .input-with-label textarea').each(function() {
            if ($(this).val().length > 0) {
                $(this).parents('.input-with-label').addClass('input-not-empty');
                $(this).parents('.input-with-label').removeClass('input-empty');
            } else {
                $(this).parents('.input-with-label').removeClass('input-not-empty');
                $(this).parents('.input-with-label').addClass('input-empty');
            }
        });
    };
    inputNotEmpty();
    $('.input-with-label input, .input-with-label textarea').focus(function() {
        $(this).parents('.input-with-label').addClass('input-focused');
        inputNotEmpty();
    });
    $('.input-with-label input, .input-with-label textarea').blur(function() {
        $(this).parents('.input-with-label').removeClass('input-focused');
        inputNotEmpty();
    });
    // END script for inputs form styles

    // BEGIN script for Progress Bar
    function checkQuizProgress() {
        _quizQuestionsQuantity = $('.form-quiz').data('quiz-questions-quantity');
        _quizQuestionCurrentNumber = $('.guiz-step-item.active').data('quiz-question');
        _quizProgress = _quizQuestionCurrentNumber / _quizQuestionsQuantity * 100;
        // console.log(_quizProgress);
        $('.quiz-progress').css('width', _quizProgress + '%');

        $('.quiz-questions-quantity').html(_quizQuestionsQuantity);
        $('.quiz-question-current-number').html(_quizQuestionCurrentNumber);
        if ($('.quiz-progress-pin').length > 0) {
            $('.quiz-progress-pin').removeClass('active')
            $('.quiz-progress-pin:nth-child(' + _quizQuestionCurrentNumber + ')').addClass('active')
        }
        if ($('.quiz-progress-step').length > 0) {
            $('.quiz-progress-step').removeClass('active')
            $('.quiz-progress-step:nth-child(' + _quizQuestionCurrentNumber + ')').addClass('active')
        }
        if ($('[data-quiz-question="1"]').hasClass('active')) {
            $('.btn-step-prev').addClass('hidden');
        } else {
            $('.btn-step-prev').removeClass('hidden');
        }
    };
    checkQuizProgress();
    // END script for Progress Bar

    // BEGIN script for Setup Default checked steps
    function setDefaultConnectedSteps() {
        $('.connect-other-step:checked').each(function() {
            _selectedInputName = $(this).attr('name');
            _selectedInputValue = $(this).val();
            // console.log(_selectedInputName);
            // console.log(_selectedInputValue);
            $('[data-selected-input-name="' + _selectedInputName + '"] > .guiz-step-item-substep').removeClass('active');
            $('[data-selected-input-value="' + _selectedInputValue + '"]').addClass('active');
        });
    };
    setDefaultConnectedSteps();
    $('.connect-other-step').change(function() {
        setDefaultConnectedSteps();
    });
    // BEGIN script for Setup Default checked steps

    // BEGIN script to init jquery validate plugin for form validation
    $.validator.setDefaults({
        ignore: []
    });
    $('.form-quiz').validate({
        highlight: function(element) {
            $(element).closest('.control-group').removeClass('success').addClass('error');
            $(element).parent().addClass('form-row-invalid');
        },
        success: function(element) {
            element
                .text('Thanks!').addClass('valid')
                .closest('.control-group').removeClass('error').addClass('success');
            $(element).parent().removeClass('form-row-invalid');
        },
        messages: {
            "medical-history": {
                required: "At last one condition is required"
            },
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") == "checkbox") {
                error.insertAfter(element.parent().parent());
            } else {
                error.insertBefore(element.parent());
                // something else if it's not a checkbox
            }
        }
    });
    // console.log($('[name="quiz_question_gender"]').valid());
    // END script to init jquery validate plugin for form validation


    // BEGIN script to check what background of active step to change header style mode to dark/white
    function checkActiveStepBG() {
        if ($('.guiz-step-item.active .guiz-step-item-inner').hasClass('bg-theme-color-dark') || $('.guiz-step-item.active .guiz-step-item-inner').hasClass('bg-theme-color')) {
            $('body').addClass('step-active-dark-mode');
        } else {
            $('body').removeClass('step-active-dark-mode');
        }
    };
    checkActiveStepBG();
    // END script to check what background of active step to change header style mode to dark/white

    // BEGIN script for Quiz Questions PREV/NEXT
    function checkCurrentStepInputsValid() {
        var _currentStepBlock = $('.guiz-step-item.active');

        var _allInputsValid = true;
        _currentStepBlock.find('input').each(function() {
            _inputValid = $(this).valid();
            _allInputsValid = _allInputsValid * _inputValid;
        });
        if (_currentStepBlock.find('select').length > 0) {
            _currentStepBlock.find('select').each(function() {
                _inputValid = $(this).valid();
                _allInputsValid = _allInputsValid * _inputValid;
            });
        }
        return _allInputsValid;
    };

    function quizStepNext() {
        fetchCartData();
        // var _quizStepCurrentNo = $('.guiz-step-item.active').data('quiz-question');
        // $('.guiz-step-item').removeClass('active');
        // $('[data-quiz-question="'+_quizStepCurrentNo+'"]').next().addClass('active');
        if (checkCurrentStepInputsValid() == 1) {
            var quizQuestionCurrentNumberValue = $('.guiz-step-item.active').data('quiz-question');
            if (quizQuestionCurrentNumberValue == 3) {

                const selectedOption = $('select[name="state"] option:selected');
                const optionclass = selectedOption.attr('class');
                if (optionclass === 'not-available') {
                    window.location = '/pages/no-state-form'
                    return
                }

                openCart();
                return;
            }
            $('.guiz-step-item.active').removeClass('active').next().addClass('active');

            checkActiveStepBG();
            checkQuizProgress();
            $('html,body').animate({
                scrollTop: 0
            }, 0);
        } else {
            $('.guiz-step-item.active input:first').focus();
        }
    };

    function quizStepNextNoCheckValid() {
        $('.guiz-step-item.active').removeClass('active').next().addClass('active')
        checkActiveStepBG();
        checkQuizProgress();
    };

    $('.btn-step-next').click(function() {
        sendDataToServer();
        $("input[name='first_name']").focus();
        //quizStepNext();
    });

    $('.btn-step-next-simple').click(function() {
        quizStepNextNoCheckValid();
    });

    $('.guiz-step-item input[type="radio"]').change(function() {
        //quizStepNext();
    });

    // $(document).on('keydown',function(e) {
    //  var keycode = (e.keyCode ? e.keyCode : e.which)
    //  // console.log(keycode);
    //  if(keycode == 13 || keycode == 39) {
    //      quizStepNext();
    //  }
    //  if(keycode == 37) {
    //      quizStepPrev();
    //  }
    // });


    function quizStepPrev() {
        var _quizStepCurrentNo = $('.guiz-step-item.active').data('quiz-question');
        if (_quizStepCurrentNo > 1) {
            // $('.guiz-step-item').removeClass('active');
            // $('[data-quiz-question="'+_quizStepCurrentNo+'"]:first').prev().addClass('active');
            $('.guiz-step-item.active').removeClass('active').prev().addClass('active');
            checkActiveStepBG();
            checkQuizProgress();
        };
    };

    $('.btn-step-prev').click(function() {
        quizStepPrev();
    });
    // END script for Quiz Questions PREV/NEXT

    // BEGIN script to init inputmask plugin
    $('[data-inputmask]').inputmask({
        placeholder: '*',
    });
    // END script to init inputmask plugin

    // BEGIN script for print in console all form filled data
    /*$('.console-log-form-data').click(function(){
      var output = $.map($(':checkbox[name=medical-history\\[\\]]:checked'), function(n, i){
            return n.value;
      }).join(',');
      console.log(output);
        formDataObject = $('.form-quiz').serializeArray();
        console.log(formDataObject);
    });*/
    $('.console-log-form-data').click(function() {
        /*  var output = $.map($(':checkbox[name=medical-history\\[\\]]:checked'), function(n, i){
            return n.value;
      }).join(',');
      console.log(output);
        formDataObject = $('.form-quiz').serializeArray();*/
        //  console.log(formDataObject);
        openCart();
    });
    // END script for print in console all form filled data

    // BEGIN of script to init bootstrap tooltip
    // var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    // var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //  return new bootstrap.Tooltip(tooltipTriggerEl)
    // })
    // END of script to init bootstrap tooltip


    function openCart() {
        const button = document.getElementById('loadButton');
        button.classList.add('loading1');
        const sessionId = getSessionId()
        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                var itemsToAdd = [{
                        id: 44587380867314,
                        quantity: 1
                    },
                    {
                        quantity: 1,
                        id: 45179934408946,
                        selling_plan: 5348753650
                        //selling_plan: 5131796722
                    },
                    {
                        id: 44591412478194,
                        quantity: 1
                    }
                ];
                const body = getBody();
                console.log(body + "SKKSKKKKSK");
                console.log(body);
                console.log(body.email);
                console.log(body.phone);
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        items: itemsToAdd,
                        attributes: {
                            ...body
                        }
                    },
                    dataType: 'json',
                    success: function(data) {
                        console.log("items added to the cart");
                        console.log(data);
                        let discount = "";
                        let utm_parameters = "?checkout[email]=" + body.email + "&checkout[shipping_address][first_name]=" + body.first_name + "&checkout[shipping_address][last_name]=" + body.last_name + "&checkout[shipping_address][phone]=" + body.phone;
                        if(window.location.href.indexOf("intake-form-v2-2025") > -1) {
                            console.log("Dont include discount");
                            utm_parameters = "?checkout[email]=" + body.email + "&checkout[shipping_address][first_name]=" + body.first_name + "&checkout[shipping_address][last_name]=" + body.last_name + "&checkout[shipping_address][phone]=" + body.phone;
                        }
                        //let utm_parameters = "?checkout[email]=" + body.email + "&checkout[shipping_address][first_name]=" + body.first_name + "&checkout[shipping_address][last_name]=" + body.last_name + "&checkout[shipping_address][phone]=" + body.phone + "&discount=heart10";
                        let final_url = "/checkout" + utm_parameters;
                        window.location = final_url;
                        //window.location = "/checkout";
                    },
                    error: function(xhr, status, error) {
                        console.log("ERROR adding items to cart");
                        console.log(error);
                    }
                });
            }
        });
    }

    $('.device-purchase').click(function() {
        b2bDevicePurchase();
    });

    function b2bDevicePurchase() {
        //const button = document.getElementById('loadButton');
        //button.classList.add('loading1');
        //const sessionId = getSessionId()
        const companyName = $("#company-name-1").val();
        const npi = $("#npi-1").val();
        console.log(npi);
        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                var itemsToAdd = [{
                    id: 51710460330347,
                    quantity: 1
                }, {
                    quantity: 1,
                    id: 51733347336555,
                    selling_plan: 691747160427
                    //selling_plan: 5131796722
                }];
                //const body = getBody();

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        items: itemsToAdd,
                        attributes: {
                            "Type": "B2B",
                            "Company-name": companyName,
                            "npi": npi
                        }
                    },
                    dataType: 'json',
                    success: function(data) {
                        console.log("items added to the cart");
                        console.log(data);
                        let discount = ""
                        //let utm_parameters="?checkout[email]="+body.email+"&checkout[shipping_address][first_name]="+body.first_name +"&checkout[shipping_address][last_name]="+body.last_name+"&checkout[shipping_address][phone]="+body.phone+"&discount=heart10";
                        let final_url = "/checkout";
                        window.location = final_url;
                        //window.location = "/checkout";
                    },
                    error: function(xhr, status, error) {
                        console.log("ERROR adding items to cart");
                        console.log(error);
                    }
                });
            }
        });
    }

    $('.device-subscription').click(function() {
        b2bDeviceSubscription();
    });

    function b2bDeviceSubscription() {
        //const button = document.getElementById('loadButton');
        //button.classList.add('loading1');
        //const sessionId = getSessionId()
        const companyName = $("#company-name").val();
        const npi = $("#npi").val();
      console.log(npi);
        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                var itemsToAdd = [{
                    quantity: 1,
                    id: 51710460100971,
                   // selling_plan: 691740442987
                    //selling_plan: 5131796722
                }, {
                    quantity: 1,
                    id: 51719406551403,
                },{
                  id:51733347762539,
                  selling_plan: 691749355883
                }];
                //const body = getBody();

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        items: itemsToAdd,
                        attributes: {
                            "Type": "B2B",
                            "Company-name": companyName,
                            "npi": npi
                        }
                    },
                    dataType: 'json',
                    success: function(data) {
                        console.log("items added to the cart");
                        console.log(data);
                        let discount = ""
                        //let utm_parameters="?checkout[email]="+body.email+"&checkout[shipping_address][first_name]="+body.first_name +"&checkout[shipping_address][last_name]="+body.last_name+"&checkout[shipping_address][phone]="+body.phone+"&discount=heart10";
                        let final_url = "/checkout";
                        window.location = final_url;
                        //window.location = "/checkout";
                    },
                    error: function(xhr, status, error) {
                        console.log("ERROR adding items to cart");
                        console.log(error);
                    }
                });
            }
        });
    }

    function getBody() {

        const formDataObject = $('.form-quiz').serializeArray();
        const agree = $("input[name='agree']:checked").val() === 'Agree'

        const body = {
            "session_id": getSessionId()
        }

        let birthMonth = ''
        let birthDay = ''
        let birthYear = ''
        let medicalHistory = []

        for (let i = 0; i < formDataObject.length; i++) {
            const item = formDataObject[i]
            const name = item.name
            const value = item.value

            if (name === 'quiz-Member-Birth-Month' && value && value !== 'Month') {
                birthMonth = value
            } else if (name === 'quiz-Member-Birth-Day' && value && value !== 'Day') {
                birthDay = value
            } else if (name === 'quiz-Member-Birth-Year' && value && value !== 'Year') {
                birthYear = value
            } else if (name === 'medical-history' && value) {
                medicalHistory.push(value)
            } else {
                body[name] = value
            }
        }

        if (birthYear && birthMonth && birthDay) {
            body['birth_date'] = `${birthYear}-${birthMonth}-${birthDay}`
        }

        if (medicalHistory.length > 0) {
            body['conditions'] = medicalHistory
            body['heart_condition'] = true
        } else {
            body['heart_condition'] = false
        }

        if (body['phone']) {
            body['phone'] = extractPlainPhoneNumber(body['phone'])
        }

        body.agree = agree
        return body;
    }

    function sendDataToServer() {

        const nextButton = document.getElementById('nextButton');
        nextButton.classList.add('loading1');

        const continueButton = document.getElementById('continueButton');
        continueButton.classList.add('loading1');

        const body = getBody();

        const sessionId = getSessionId()
        //let url = `https://hook.us1.make.com/88w31hxdmjywa9zaif0jis2i9ve4jti5`
        let url = `https://smartheart-shopify-voxyb726rq-uw.a.run.app/api/v1/intake/${sessionId}`
        var settings = {
            "url": url,
            "method": "POST",
            "timeout": 0,
            "headers": {
                "Content-Type": "application/json"
            },
            "data": JSON.stringify(body),
        };
      
        $.ajax(settings)
            .done(function(response) {
                nextButton.classList.remove('loading1');
                continueButton.classList.remove('loading1');
                quizStepNext();
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                nextButton.classList.remove('loading1');
                continueButton.classList.remove('loading1');
                var quizQuestionCurrentNumberValue = $('.guiz-step-item.active').data('quiz-question');
                console.log('quizQuestionCurrentNumberValue', quizQuestionCurrentNumberValue)
                if (quizQuestionCurrentNumberValue == 2) {
                    try {
                        const error = JSON.parse(jqXHR.responseText)
                        alert(error.message)
                        return
                    } catch (e) {

                    }
                    alert(textStatus)
                } else {
                    quizStepNext();
                }
            });

      // Pushing to sandbox
      let url1 = `https://smartheart-shopify-sandbox-voxyb726rq-uw.a.run.app/api/v1/intake/${sessionId}`
      var settings1 = {
          "url": url1,
          "method": "POST",
          "timeout": 0,
          "headers": {
              "Content-Type": "application/json"
          },
          "data": JSON.stringify(body),
      };
      $.ajax(settings1)
          .done(function(response) {
              console.log('sandbox hit success');
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
          });  
    }

    function getSessionId() {
        /*let sessionId = localStorage.getItem("quiz-session-id");
        if (!sessionId) {
            sessionId = generateUUID();
            localStorage.setItem("quiz-session-id", sessionId);
        }
        return sessionId;*/

        return globalSessionId;
    }

    function generateUUID() {
        // Create an array of 16 bytes
        const array = new Uint8Array(16);
        window.crypto.getRandomValues(array);

        // Set version to 4 (random)
        array[6] = (array[6] & 0x0f) | 0x40;
        // Set bits 6-7 to 10
        array[8] = (array[8] & 0x3f) | 0x80;

        // Convert byte array to hex string
        const hexArray = Array.from(array, byte => byte.toString(16).padStart(2, '0'));

        // Format UUID
        const uuid = `${hexArray.slice(0, 4).join('')}-${hexArray.slice(4, 6).join('')}-${hexArray.slice(6, 8).join('')}-${hexArray.slice(8, 10).join('')}-${hexArray.slice(10).join('')}`;

        return uuid;
    }

    function getDataFromSessionId() {
        const sessionId = getSessionId()
        var settings = {
            "url": `https://smartheart-shopify-voxyb726rq-uw.a.run.app/api/v1/intake/${sessionId}`,
            "method": "GET",
            "timeout": 0,
        };

        $.ajax(settings).done(function(response) {
            const heart_condition = response.heart_condition
            const first_name = response.first_name
            const last_name = response.last_name
            const email = response.email
            const phone = extractPlainPhoneNumber(response.phone)
            const conditions = response.conditions
            const birth_date = response.birth_date
            const state = response.state
            const gender = response.gender

            $("input[name='first_name']").val(first_name);
            $("input[name='last_name']").val(last_name);
            $("input[name='email']").val(email);
            $("input[name='phone']").val(phone);
            $("input[name='gender'][value='" + gender + "']").prop("checked", true)

            console.log('heart_condition', conditions)
            $('#tab-11').removeClass('active');
            $('#tab-1').removeClass('active');
            $('#tab-22').removeClass('active');
            $('#tab-2').removeClass('active');
            if (heart_condition) {
                $('#tab-11').addClass('active');
                $('#tab-1').addClass('active');
            } else {
                $('#tab-22').addClass('active');
                $('#tab-2').addClass('active');
            }

            $('input[name="medical-history"]').each(function() {
                var checkboxValue = $(this).val();
                if (conditions && conditions.includes(checkboxValue)) {
                    $(this).prop('checked', true);
                }
            });

            $("select[name='state']").val(state);
            if (birth_date) {
                const split = birth_date.split('-')
                if (split.length === 3) {
                    const year = split[0]
                    const month = split[1]
                    const day = split[2]
                    $("select[name='quiz-Member-Birth-Month']").val(month);
                    $("select[name='quiz-Member-Birth-Year']").val(year);
                    $("select[name='quiz-Member-Birth-Day']").val(day);
                }
            }


        });
    }

    function extractPlainPhoneNumber(formattedNumber) {
        return formattedNumber.replace(/\D/g, '');
    }

    function fetchCartData() {
        console.log('Fetching cart:');
        $.getJSON('/cart.js', function(cart, error) {
            console.log('Current cart:', cart);
            console.log('Current cart:', error);
            // Handle cart data
        });
    }

    function updateCartAttributes(attributes) {
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                attributes: attributes
            },
            dataType: 'json',
            success: function(cart) {
                console.log('Cart attributes updated successfully:', cart);
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error updating cart attributes:', textStatus);
            }
        });
    }

    function getSessionIdV2() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
                console.log('Current cart:', cart);
                console.log('sessionId', cart.attributes.sessionId)
                if (!cart?.attributes?.sessionId) {
                    storeSessionId()
                } else {
                    globalSessionId = cart.attributes.sessionId
                    getDataFromSessionId();
                }
            },
            error: function(error) {
                console.log('Error retrieving cart:', error);
            }
        });
    }

    function storeSessionId() {
        const sessionId = generateUUID()
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                attributes: {
                    sessionId: sessionId
                }
            },
            dataType: 'json',
            success: function(updatedCart) {
                console.log('Cart updated:', updatedCart);
                globalSessionId = sessionId
            },
            error: function(error) {
                console.log('Error updating cart:', error);
            }
        });
    }

    $(document).ready(function() {
        getSessionIdV2();
        //getDataFromSessionId();
    });

    // END QUIZ -----------------------------------------------------

    // VERIFY Email Start -----------------------------------------------------

    function storeCreditEmail(email, redirect, rechargeId) {
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                attributes: {
                    credtEmail : email || '',
                    rechargeId : rechargeId || ''
                }
            },
            dataType: 'json',
            success: function(updatedCart) {
                console.log('Cart updated:', updatedCart);
                if(redirect)
                  window.location.href = '/products/12-lead-ecg-reports-interpreted-by-u-s-licensed-cardiologists';
            },
            error: function(error) {
                console.log('Error updating cart:', error);
            }
        });
    }

    function removeCreditEmail() {
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                attributes: {
                    credtEmail: '',
                    rechargeId: ''
                }
            },
            dataType: 'json',
            success: function(updatedCart) {
                console.log('Cart updated:', updatedCart);
            },
            error: function(error) {
                console.log('Error updating cart:', error);
            }
        });
    }


    function checkCreditEmail() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
                console.log('Current cart checkCredit:', cart);
                console.log('credtEmail', cart.attributes.credtEmail)
                if (!cart?.attributes?.credtEmail && !cart?.attributes?.rechargeId) { // email not present
                    window.location.href = '/pages/verify-customer';        
                } else { // email present
                    
                }
            },
            error: function(error) {
                console.log('Error retrieving cart:', error);
            }
        });
    }

    

    function checkIsECGCreditPage() {
        const currentPage = window.location.pathname;
        if (currentPage.includes("/products/12-lead-ecg-reports-interpreted-by-u-s-licensed-cardiologists")) {
          /*const verifiedEmail = localStorage.getItem('CREDIT_EMAIL')
          if(!verifiedEmail) {
            window.location.href = '/pages/verify-customer';
          }*/


          const params = new URLSearchParams(window.location.search);
          if (params.has('email')) {
              console.log('Email parameter exists:', params.get('email'));
              const email = params.get('email')
              $.ajax({
                  type: 'GET',
                  url: `https://smartheart-shopify-voxyb726rq-uw.a.run.app/api/v1/shopify/verify/customer?email=${email}`,
                  dataType: 'json',
                  success: function() {
                      console.log('----> URL param email true');
                      storeCreditEmail(email, false, '')
                  },
                  error: function(error) {
                      console.log('----> URL param email false');
                      removeCreditEmail()
                      window.location.href = '/pages/verify-customer';
                  }
              });
          } else if (params.has('rechargeId')) {
              console.log('RechargeId parameter exists:', params.get('rechargeId'));
              const rechargeId = params.get('rechargeId')
              $.ajax({
                  type: 'GET',
                  url: `https://smartheart-shopify-voxyb726rq-uw.a.run.app/api/v1/shopify/verify/recharge_id?rechargeId=${rechargeId}`,
                  dataType: 'json',
                  success: function(response) {
                      console.log('----> URL param rechargeId true', response);
                      storeCreditEmail('', false, rechargeId)
                  },
                  error: function(error) {
                      console.log('----> URL param email false');
                      removeCreditEmail()
                      window.location.href = '/pages/verify-customer';
                  }
              });
          } else {
            checkCreditEmail()
          }
          
        }
        if(currentPage.includes("/pages/verify-customer")){
          /*localStorage.removeItem('CREDIT_EMAIL')*/
          removeCreditEmail()
        }
        if(currentPage.includes("/pages/purchase-ecg-credits")){
          const params = new URLSearchParams(window.location.search);
          if (params.has('rechargeId')) {
              console.log('RechargeId parameter exists:', params.get('rechargeId'));
              const rechargeId = params.get('rechargeId')
              //window.location.href = `/products/12-lead-ecg-reports-interpreted-by-u-s-licensed-cardiologists?rechargeId=${rechargeId}`;
              $.ajax({
                  type: 'GET',
                  url: `https://smartheart-shopify-voxyb726rq-uw.a.run.app/api/v1/shopify/verify/recharge_id?rechargeId=${rechargeId}`,
                  dataType: 'json',
                  success: function(response) {
                      console.log('----> URL param rechargeId true', response);
                      storeCreditEmail('', true, rechargeId)
                  },
                  error: function(error) {
                      console.log('----> URL param email false');
                      removeCreditEmail()
                      window.location.href = '/pages/verify-customer';
                  }
              });
          }
          //removeCreditEmail()
        }
    }

    function btnClickVerifyEmail() {
      $("#btn-verify-email").on("click", function() {
            const email = $("#input-verify-email").val()
            if (email) {
                $.ajax({
                    type: 'GET',
                    //url: `https://smartheart-shopify-sandbox-voxyb726rq-uw.a.run.app/api/v1/shopify/verify/customer?email=${email}`,
                    url: `https://smartheart-shopify-voxyb726rq-uw.a.run.app/api/v1/shopify/verify/customer?email=${email}`,
                    dataType: 'json',
                    success: function(updatedCart) {
                        /*localStorage.setItem('CREDIT_EMAIL', email)*/
                        storeCreditEmail(email, true)
                    },
                    error: function(error) {
                        alert('We could not find an account linked to that email. Please try another email or contact support.')
                    }
                });
            }
        });
    }
  
    $(document).ready(function() {
        checkIsECGCreditPage();
        btnClickVerifyEmail();
    });
    // VERIFY Email End -----------------------------------------------------
  console.log("SYYYSYS");
  console.log(window.location.pathname);
  let pathname = window.location.pathname;
  if (pathname.includes("cart")) {
    console.log("true");
    document.location.href = '/cart/checkout';
  }

  //console.log(window.location.href);
  if (window.location.href.indexOf("12-lead-ecg-reports-interpreted-by-u-s-licensed-cardiologists") > -1) {
      //alert("your url contains the name franky");
     $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
              console.log("Clear ECG Cart")
            }
     })
    }

});